export const isNotReady = (process: TrainReadyProcessView) =>
  process.messages.some(
    ({ raw }) =>
      "status" in raw && raw.status === "REQUESTED" && raw.data?.ready === false
  );

/** The user who issued the request of the process, if known. */
export const requestUser = (process: TrainReadyProcessView) =>
  process.messages.find(({ user }) => user)?.user ?? undefined;
